import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class SOVendorRequest {
    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number[];
    @ApiProperty()
    @IsNotEmpty()
    vendorId: number;
}